import { createActionCreator } from "deox";
import { IFormCategoryModel, ILookupItemModel } from "../../../types/types";

export const hiddenFieldsLoading = createActionCreator("hiddenFields/loading");
export const hiddenFieldsLoaded = createActionCreator(
  "hiddenFields/loaded",
  (resolve) => (payload: ILookupItemModel[]) => resolve(payload)
);
export const hiddenFieldsError = createActionCreator(
  "hiddenFields/error",
  (resolve) => (error: string) => resolve(error)
);
export const fieldHidden = createActionCreator(
  "hiddenFields/hidden",
  (resolve) => (id: number, name: string) => resolve({ id, name })
);
export const fieldShown = createActionCreator(
  "hiddenFields/shown",
  (resolve) => (id: number) => resolve(id)
);

export const fieldToggleVisibilityInit =
  createActionCreator("hiddenFields/init");

export const togglingFieldVisibility = createActionCreator(
  "hiddenFields/toggling"
);
